import { AuthLayout } from "../commons/authLayout/authLayout";
import { ResetPasswordForm } from "../features/resetPasswordForm";

export const ResetPasswordPage = () => {
  return (
    <AuthLayout>
      <ResetPasswordForm />
    </AuthLayout>
  );
};
